import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

function InactivityWarningModal() {
  const { t } = useTranslation();
  const { showInactivityWarning, extendSession, logout } = useAuth();
  const [countdown, setCountdown] = useState(60);

  useEffect(() => {
    if (showInactivityWarning) {
      setCountdown(60);
      
      const interval = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [showInactivityWarning]);

  if (!showInactivityWarning) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6 animate-fade-in">
        {/* Icon */}
        <div className="flex items-center justify-center w-12 h-12 mx-auto bg-yellow-100 rounded-full mb-4">
          <svg 
            className="w-6 h-6 text-yellow-600" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
            />
          </svg>
        </div>

        {/* Title */}
        <h3 className="text-xl font-bold text-gray-900 mb-2 text-center">
          {t('inactivity.title', 'Session endet bald')}
        </h3>

        {/* Message */}
        <div className="text-center mb-6">
          <p className="text-gray-700 mb-3">
            {t('inactivity.message', 'Sie werden aufgrund von Inaktivität in')}
          </p>
          <div className="text-4xl font-bold text-yellow-600 mb-2">
            {countdown}
          </div>
          <p className="text-gray-600 text-sm">
            {t('inactivity.seconds', 'Sekunden ausgeloggt.')}
          </p>
        </div>

        {/* Buttons */}
        <div className="flex gap-3">
          <button
            onClick={extendSession}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
          >
            {t('inactivity.stayLoggedIn', 'Eingeloggt bleiben')}
          </button>
          <button
            onClick={logout}
            className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded-lg transition-colors"
          >
            {t('inactivity.logoutNow', 'Jetzt ausloggen')}
          </button>
        </div>

        {/* Info */}
        <p className="text-xs text-gray-500 text-center mt-4">
          {t('inactivity.info', 'Aus Sicherheitsgründen werden Sie nach 10 Minuten Inaktivität automatisch abgemeldet.')}
        </p>
      </div>
    </div>
  );
}

export default InactivityWarningModal;
